export const LOCAL_STORAGE_KEY = "Replay:UserPreferences";
